import {useState} from 'react';
import {UserOutlined} from '@ant-design/icons';

const SIZES = {
  sm: 22,
  md: 28,
  lg: 40,
};

export const TicketUserAvatar = ({
  imageUrl,
  initials,
  size = 'md',
  className,
  style,
}) => {
  const [errored, setErrored] = useState(false);
  const dim = SIZES[size] || SIZES.md;
  const showImage = imageUrl && !errored;
  const showInitials = !showImage && initials;

  const baseStyle = {
    width: dim,
    height: dim,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: `0 0 ${dim}px`,
    overflow: 'hidden',
    background: showImage
      ? '#e2e8f0'
      : 'linear-gradient(135deg, #dbeafe, #bfdbfe)',
    color: '#2563eb',
    fontSize: Math.max(10, Math.round(dim * 0.42)),
    fontWeight: 700,
    lineHeight: 1,
    ...style,
  };

  return (
    <span className={className} style={baseStyle} aria-hidden="true">
      {showImage ? (
        <img
          src={imageUrl}
          alt=""
          onError={() => setErrored(true)}
          style={{width: '100%', height: '100%', objectFit: 'cover'}}
        />
      ) : showInitials ? (
        <span>{String(initials).slice(0, 2).toUpperCase()}</span>
      ) : (
        <UserOutlined />
      )}
    </span>
  );
};
